import { Capacitor } from "@capacitor/core";

export const streamApikey = import.meta.env.VITE_STREAM_KEY ?? "xyndvxnzrkh4";

export const mixpanelToken = "f41e5f9ab418cd98a75adbf6ecf4da36";

const iosApiLocalhost = "http://localhost:8000";
const androidApiLocalhost = "http://10.0.2.2:8000";
export const apiUrl =
  import.meta.env.VITE_API_URL ??
  (Capacitor.getPlatform() === "android"
    ? androidApiLocalhost
    : iosApiLocalhost);

export const revenuecatApiKey = {
  ios: "appl_tFnRpFOEPJpYMbVMGWyuGVGEMLd",
  android: "goog_VJgSvAZqeanOvORLPCxMZqNddmB",
}[Capacitor.getPlatform()];

export const sentryDsn =
  "https://294dc4f023bf356be70e3d228f001d81@o4508880208723968.ingest.de.sentry.io/4508880413917264";

export const tosUrl = {
  default: "https://www.mentory.app/nutzungsbedingungen",
  us: "https://us.mentory.app/terms-of-service",
};

export const privacyUrl = {
  default: "https://www.mentory.app/privacy",
  us: "https://us.mentory.app/privacy",
};

export const appStoreUrl =
  "https://apps.apple.com/de/app/mentory-mentoring-app/id6532605311";
export const googlePlayUrl =
  "https://play.google.com/store/apps/details?id=app.mentory.mentory";
